const PREFIX = 'CompGroupLabel';

export const compGroupLabelClasses = {
  compGroupLabelInitials: `${PREFIX}-compGroupLabelInitials`,
};
